
export default {
    namespaced: true,
    state: {
        chartData: {},
        siteList: {},
        from: null,
        to: null,
        currentSiteId: null,
        minDate: null,
        maxDate: null,
        currentGroup: 'month',
    },
    getters: {
        MIN_DATE: state => {
            return state.minDate;
        },
        MAX_DATE: state => {
            return state.maxDate;
        },
        FROM: state => {
            return state.from;
        },
        TO: state => {
            return state.to;
        },
        SITE_LIST: state => {
            return state.siteList;
        },
        CURRENT_SITE_ID: state => {
            return state.data;
        },
        CHART_DATA: state => {
            return state.chartData;
        },
        CURRENT_GROUP: state => {
            return state.currentGroup;
        },
    },
    mutations: {
        MIN_DATE: (state, payload) => {
            return state.minDate = payload;
        },
        MAX_DATE: (state, payload) => {
            return state.maxDate = payload;
        },
        FROM: (state, payload) => {
            return state.from = payload;
        },
        TO: (state, payload) => {
            return state.to = payload;
        },
        SITE_LIST: (state, payload) => {
            return state.siteList = payload;
        },
        CHART_DATA: (state, payload) => {
            return state.chartData = payload;
        },
        CURRENT_SITE_ID: (state, payload) => {
            return state.currentSiteId = payload;
        },
        CURRENT_GROUP: (state, payload) => {
            return state.currentGroup = payload;
        },
    },
    actions: {
        GET_DATA: async ({state}, payload) => {
            payload.th.showOverlay ++;
            state.chartData = {}

            await payload.th.$store.dispatch('SEND_GET', {
                url: '/site-chart-statistic/'+ state.currentSiteId +'/'+ state.currentGroup
                    +'?from='+ state.from
                    +'&to='+ state.to
                ,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (response) => {
                    // set site list
                    state.siteList = [];
                    for (let key in response.siteList) {
                        let val = response.siteList[key]
                        state.siteList.push({
                            value: val.id.toString(), text: val.domain
                        })
                    }
                    // chart data
                    state.chartData = response.chartStatistic
                    payload.th.reRenderChart = !payload.th.reRenderChart
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },
        GET_EXTRIMAL_DATE: async ({state}, payload) => {
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/site-statistic-date/'+ state.currentSiteId,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (response) => {
                    state.minDate = response.min
                    state.maxDate = response.max
                    // get data
                    payload.th.getData()
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },

    }
}